import React from "react";
import { Box, Typography, Chip, Grid, Button, IconButton, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import SelectableRadioGroupManager from "../../selectable-radio-group-manger";
import MicIcon from "@mui/icons-material/Mic";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const behaviorCriteria = ["Self-harm", "Damaging property", "Others"];

const behaviorOptions = [
  "Punching",
  "Hitting",
  "Kicking",
  "Biting",
  "Disruption to activity",
  "Head butting",
  "Persistent refusal to follow a request",
  "Pinching",
  "Spitting",
  "Verbally threatening",
  "Attempt to abscond",
  "Damage to property",
  "Using objects as a weapon",
  "Self-injurious behaviors",
  "Scratching",
  "Other",
];

const NonPhysicalBehaviorManager = ({ behaviourData, nextStep, prevStep }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store

  const allowedBehaviors = behaviourData?.map((b) => b.behavior);

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Non - Physical Intervention</Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item lg={8} md={8}>
          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black", mb: 2 }}>
            Identify which of the following criteria the behavior met.
          </Typography>

          <SelectableRadioGroupManager options={behaviorCriteria} allowedOptions={allowedBehaviors} />

          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black", mb: 2, mt: 3 }}>
            Antecedent behaviors
          </Typography>

          <SelectableRadioGroupManager options={behaviorOptions} allowedOptions={allowedBehaviors} />
        </Grid>
        <Grid item lg={4} md={4}>
          {/*  Non - Physical Intervention Details Section - Recorded Entries */}
          <Box sx={{ mt: 4 }}>
            <Typography sx={{ fontSize: "16px", color: "black", fontWeight: "bold", mb: 2 }}>
              Non - Physical Intervention
            </Typography>

            {behaviourData.length > 0 ? (
              <>
                {[
                  { title: "Identify which of the following criteria the behavior met.", data: behaviorCriteria },
                  { title: "Antecedent behaviors", data: behaviorOptions },
                ].map((category, index) => (
                  <Box key={index} sx={{ mt: 2 }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "regular", mb: 1, color: "grey" }}>
                      {category.title}
                    </Typography>
                    {behaviourData
                      .filter((record) => category.data.includes(record.behavior))
                      .map((record, recordIndex) => (
                        <Paper
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 1,
                            mb: 1,
                            borderRadius: 2,
                            border: "1px solid #ccc",
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", color: "black" }}>
                            {record.audio ? (
                              record.behavior
                            ) : (
                              <>
                                {record.behavior}
                                <br />
                                {record.note}
                              </>
                            )}
                          </Typography>

                          <Box>
                            {record.audio && (
                              <>
                                <IconButton onClick={() => window.open(record.audio, "_blank")}>
                                  <MicIcon color='primary' />
                                </IconButton>
                                <IconButton onClick={() => window.open(record.audio, "_blank")}>
                                  <CloudDownloadIcon color='primary' />
                                </IconButton>
                              </>
                            )}
                          </Box>
                        </Paper>
                      ))}
                  </Box>
                ))}
              </>
            ) : (
              <Typography sx={{ fontSize: "14px", color: "gray" }}>No incident records found.</Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button
          variant='outlined'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            prevStep();
          }}
        >
          Previous
        </Button>

        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            nextStep(); // Call the function properly
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default NonPhysicalBehaviorManager;
